import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Wrapper } from "./payFullArrears.styles";
import { PayFullArrearsOptions } from "./payFullArrearsOptions";
import { PAY_FULL_ARREARS_ROUTE } from "../IncreaseRepayments/route.constants";
import { PayDebitCard } from "../IncreaseRepayments/components/MakeExtraRepayments/payDebitCard";
import { PayArrearsDirectDebit } from "./payArrearsDirectDebit";
import { PayBankTransfer } from "../IncreaseRepayments/components/MakeExtraRepayments/payBankTransfer";

export const PayFullArrears = ({ accountId }) => {
  const { path } = useRouteMatch();

  return (
    <Wrapper>
      <PayFullArrearsOptions exact path={path} />
      <Switch>
        <Route path={path + PAY_FULL_ARREARS_ROUTE.DEBIT_CARD}>
          <PayDebitCard accountId={accountId} isFullArrears={true} />
        </Route>
        <Route path={path + PAY_FULL_ARREARS_ROUTE.BANK_TRANSFER}>
          <PayBankTransfer accountId={accountId} />
        </Route>
          <Route path={path + PAY_FULL_ARREARS_ROUTE.DIRECT_DEBIT}>
            <PayArrearsDirectDebit accountId={accountId} />
          </Route>
        )
      </Switch>
    </Wrapper>
  );
};
